import SimpleSlider from "components/SimpleSlider";
import { ModuleContext } from "contexts/ModuleContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "styles/modules/importClaims.module.scss";
import ComponentsTitleRow from "components/modules/ComponentsTitleRow";
import { moduleScreens } from "pages/module/ModuleUtil";
import ClaimSummaryBox from "components/modules/claims/ClaimSummaryBox";
import ReusableTextSummaryBox from "components/modules/reusableTexts/ReusableTextSummaryBox";
import TextComponent from "components/modules/TextComponent";
import DataGraphic from "./components/DataGraphicCard";
import CustomModal from "components/customModal";
import ViewTextElement from "./ViewTextElement";

/**
 * To display claims and reusable texts
 * @param {*} param0
 * @returns
 */
const ModuleTextAttributes = ({ elementLabel, elementType }) => {
  const { t } = useTranslation();
  const { module, activeScreen, currentActiveElementIndex } =
    useContext(ModuleContext);
  const sliderRef = useRef();
  const [isLoading, setIsloading] = useState(false);
  const [componentView, setComponentView] = useState(false);
  const [elementTypes, setElementTypes] = useState(undefined);
  const [selectectedtextElement, setSelectectedtextElement] =
    useState(undefined);
  const [showClaimSummaryBox, setShowClaimSummaryBox] = useState(false);

  const columnSize = activeScreen === moduleScreens.reusableTexts ? 12 : 5;

  useEffect(() => {
    goToSlide(currentActiveElementIndex);
  }, [currentActiveElementIndex]);

  const goToSlide = (slideIndex) => {
    if (sliderRef && sliderRef.current) {
      sliderRef.current.slickGoTo(slideIndex);
    }
  };

  const renderTextualComponents = () => {
    if (!module) {
      return;
    }

    return module[elementType]?.map((el, index) => {
      return (
        <div key={index} style={{ width: "100%" }}>
          <div className="row">
            {activeScreen !== moduleScreens.reusableTexts ? (
              <>
                <div
                  className={
                    el.relatedClaims?.length > 0 ? "col-md-8" : "col-md-12"
                  }
                >
                  <div className={styles.styledBox}>
                    <div className="row">
                      <div className="col-md-4 p-6">
                        <ClaimSummaryBox
                          claim={el}
                          customStyleVariant="customStyleWhite"
                        />
                      </div>

                      <div className="col-md-4 p-0">
                        <TextComponent
                          title="References"
                          data={
                            el.references
                              ? el.references.map((ref, index) => ({
                                  content: `${index + 1}. ${ref.documentName}`,
                                }))
                              : []
                          }
                          componentType={3}
                          customClass={styles.customHeightMedium}
                        />
                        <TextComponent
                          title="Abbreviations"
                          data={[{ content: el.abbreviation }]}
                          componentType={1}
                          customClass={styles.customHeightMedium}
                        />
                      </div>
                      <div className="col-md-4 p-6">
                        <TextComponent
                          title="Footnotes"
                          data={[{ content: el.footnotes }]}
                          componentType={1}
                          customClass={styles.customHeightLarge}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {el.relatedClaims?.length > 0 && (
                  <div className="col-md-4">
                    <DataGraphic
                      title={`Related Claims (${el.relatedClaims.length})`}
                      data={el.relatedClaims}
                      setIsloading={setIsloading}
                      onClick={(relatedClaim) => {
                        const allRelatedClaims = el.relatedClaims;
                        const clickedIndex = allRelatedClaims.findIndex(
                          (item) => item.id === relatedClaim.id
                        );
                        setSelectectedtextElement({
                          clickedItem: relatedClaim,
                          clickedIndex,
                          fullList: allRelatedClaims,
                        });
                        setComponentView(true);
                        setElementTypes(1);
                        setShowClaimSummaryBox(true);
                      }}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="col-md-12">
                <ReusableTextSummaryBox reusableText={el} />
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="row mt-3 mb-3 align-items-center">
        <ComponentsTitleRow
          elementLabel={`${elementLabel.toUpperCase()} (${
            currentActiveElementIndex + 1
          })`}
        />
      </div>

      {
        <div className={`${styles.sliderheight}`}>
          <SimpleSlider
            children={renderTextualComponents()}
            sliderRef={sliderRef}
          />
        </div>
      }

      <CustomModal
        displayModal={componentView}
        hideModal={() => {
          setComponentView(false);
          setElementTypes(undefined);
        }}
        size={elementTypes === 1 ? "lg" : "datagraphic"}
        dilogClassName="alertModalSmall custom-modal-size-climes"
      >
        <ViewTextElement
          viewTextualElementType={elementTypes}
          selectectedtextElement={selectectedtextElement?.clickedItem}
          toggleComponentView={setComponentView}
          data={selectectedtextElement?.fullList || []}
          activeIndex={selectectedtextElement?.clickedIndex}
          showClaimSummaryBox={showClaimSummaryBox}
        />
      </CustomModal>
    </>
  );
};

export default ModuleTextAttributes;
